/* eslint-disable react-hooks/exhaustive-deps */
import { useTvmWalletService } from '@broxus/tvm-connect';
import { useEffect } from 'react';

import { store } from '@/store';

export const useWallet = (
  walletService: ReturnType<typeof useTvmWalletService>,
) => {
  const walletStore = store.wallet;

  const checkNetwork = async () => {
    const state = await walletService.provider?.getProviderState();

    walletStore.setState({ ...state });

    if (state?.networkId === walletStore.networkId) return;

    walletService.provider?.changeNetwork({ networkId: walletStore.networkId });
  };

  const checkWallet = async () => {
    const state = await walletService.provider?.getProviderState();

    if (state?.networkId !== walletStore.networkId) return;

    const address = walletService.address?.toString();

    try {
      await store.app.checkWallet(address);
    } catch (error) {
      walletService.disconnect();
      console.error(error);
    }
  };

  useEffect(() => {
    if (!walletService.isConnected) return;

    checkNetwork();
    checkWallet();
  }, [walletService.isConnected]);
};
